import { useQuery, UseQueryOptions } from "react-query";
import { IRequest } from "../interfaces/authentication.interface";
import { useQueryClient } from 'react-query';
import { IHomepage } from "../interfaces/home.interface";
import { getHomepage } from "../services/homepage.service";

export function useGetHome<T extends any = IRequest<IHomepage>>(
    options?: UseQueryOptions<any, unknown, T>
) {

    const cache = useQueryClient().getQueryData(["home"]);

    return useQuery({
        queryKey: ["home"],
        queryFn: () => cache ? cache : getHomepage(),
        retry: 1,
        refetchOnWindowFocus: false,
        staleTime: 15 * 60 * 1000,
        ...options
    });
}
